// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3izjZ","savePackageButton":"ClientWallet_savePackageButton__3rcaG"};